import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './NumberCircle.module.scss';
const NumberCircle = ({ text, size = 'normal', reverse = false }) => {
    return (_jsx("div", Object.assign({ className: cn(styles.element, reverse && styles.reverse, styles[`hasSize-${size}`]) }, { children: _jsx("span", { children: text }) })));
};
export default NumberCircle;
